/* Falaq WhatsApp router.
   13 Oct 2026: every WhatsApp link on the site goes to one of the store numbers instead of the owner's
   number. Each visitor gets one store at random and keeps it for the day, so all stores share the
   messages. The message says clearly that the customer is writing from the website, with the piece,
   option, price and link on product pages.
   20 Oct 2026: Qurum (Ahad Jewelry) removed by the owner; Falaq stores only.
   21 Oct 2026: owner's number removed from the whole site. Links to "/pages/stores#whatsapp" (or any
   link carrying data-falaq-wa) open the visitor's store on WhatsApp; without JavaScript they land on the
   Stores page, which lists the three store numbers. Safety net: any leftover owner number in links
   (wa.me or tel:) or in visible text is swapped for the visitor's store.
   21 Oct 2026 (later): "Order on WhatsApp" button under Buy it now on product pages and under
   Check out in the cart drawer and cart page (data-falaq-wa="order" / "order-cart"). The message is an
   order, not a question: piece(s), option, quantity, price, link. Clicks are reported to Meta
   (WhatsAppOrder) and to Shopify customer events (falaq_whatsapp_order) so they can be counted.
   Instant cart: Add to cart opens the cart drawer at once with an "Adding" line instead of waiting
   ~1.5 s (longer on mobile data) for the server; the theme fills it in when the reply arrives. */
(function () {
  var STORES = [
    { name: 'Mawaleh', phone: '96893555266', label: '+968 9355 5266' },
    { name: 'Sohar', phone: '96899185515', label: '+968 9918 5515' },
    { name: 'Khaburah', phone: '96893322772', label: '+968 9332 2772' }
  ];
  var OWNER = '36023859'.split('').reverse().join('');
  var AR = '٠١٢٣٤٥٦٧٨٩';
  function sp(x) { return x.split('').join('[\\s\\-]*'); }
  function ar(x) { return x.replace(/[0-9]/g, function (d) { return AR[+d]; }); }
  var OWNER_TEXT = new RegExp('(?:‎|‏)?(?:\\+?\\s*968[\\s\\-]*)?' + sp(OWNER) + '|(?:\\+?' + ar('968') + '\\s*)?' + sp(ar(OWNER)), 'g');
  function isAr() { return (document.documentElement.lang || '').indexOf('ar') === 0; }
  function today() {
    var d = new Date(Date.now() + (new Date().getTimezoneOffset() + 240) * 60000);
    return d.toISOString().slice(0, 10);
  }
  function pickStore() {
    var key = 'falaq_wa_store', t = today(), v;
    try { v = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { v = null; }
    if (v && v.d === t && STORES[v.i]) return STORES[v.i];
    var i = Math.floor(Math.random() * STORES.length);
    try { localStorage.setItem(key, JSON.stringify({ d: t, i: i })); } catch (e) {}
    return STORES[i];
  }
  function digits(s) { return (s || '').replace(/[^0-9]/g, ''); }
  function isRouterLink(a) {
    if (a.hasAttribute('data-falaq-wa')) return true;
    var h = a.getAttribute('href') || '';
    if (/#whatsapp$/i.test(h)) return true;
    if (/^tel:/i.test(h) && digits(h).indexOf(OWNER) > -1) return true;
    return /wa\.me|whatsapp\.com/i.test(h) && digits(h).indexOf(OWNER) > -1;
  }
  function mainForm() {
    return document.querySelector('product-info form[is="product-form"], .main-product-form');
  }
  function selectedOptions() {
    var scope = document.querySelector('product-info, .product__info-container, main') || document;
    var vals = [];
    scope.querySelectorAll('input[type=radio]:checked').forEach(function (r) {
      if (r.name && !/^FalaqUS/.test(r.id) && r.value) vals.push(r.value);
    });
    if (!vals.length) {
      scope.querySelectorAll('select').forEach(function (s) {
        if (!s.closest('[data-falaq-sizehelp]') && s.value && s.name && s.name.indexOf('options') > -1) vals.push(s.value);
      });
    }
    return vals.join(' / ');
  }
  var product = null;
  if (/\/products\/[^\/]+\/?$/.test(location.pathname)) {
    fetch(location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { product = p; })
      .catch(function () {});
  }
  function money(v) { return (v / 100).toFixed(3); }
  function cur(code) { return isAr() ? (code === 'OMR' || !code ? 'ر.ع' : code) : (code || 'OMR'); }
  /* Order message, one block per piece: name, options, barcode, quantity and price.
     The "925 silver, 24K gold plated" part of each title is said once at the bottom instead. */
  function shortTitle(t) {
    var i = (t || '').lastIndexOf(' - ');
    return i > 0 && /925/.test(t.slice(i)) ? t.slice(0, i) : (t || '');
  }
  function orderMessage(items, link) {
    var a = isAr();
    var c = a ? 'ر.ع' : 'OMR';
    var total = 0;
    var out = [a ? '*طلب من الموقع* · falaqjewelry.com' : '*Website order* · falaqjewelry.com', ''];
    items.forEach(function (it, i) {
      total += it.line;
      out.push('*' + (items.length > 1 ? (i + 1) + ') ' : '') + shortTitle(it.title) + '*');
      var opts = (it.options || []).filter(function (o) { return o.value && o.name !== 'Title'; })
        .map(function (o) { return o.name + ': ' + o.value; });
      if (opts.length) out.push(opts.join(' · '));
      if (it.barcode) out.push((a ? 'الباركود: ' : 'Barcode: ') + '`' + it.barcode + '`');
      out.push((a ? 'الكمية: ' : 'Qty: ') + it.qty + ' · ' + money(it.line) + ' ' + c);
      out.push('');
    });
    out.push('━━━━━━━━━━');
    out.push((a ? '*المجموع: ' : '*Total: ') + money(total) + ' ' + c + '*');
    out.push(a ? '_قبل التوصيل · جميع القطع فضة 925 مطلية بذهب عيار 24_' : '_Before delivery · all pieces 925 silver, 24K gold plated_');
    out.push('');
    if (link) { out.push((a ? 'الرابط: ' : 'Link: ') + link); out.push(''); }
    out.push(a ? (items.length > 1 ? 'السلام عليكم، أرغب بطلب هذه القطع.' : 'السلام عليكم، أرغب بطلب هذه القطعة.')
               : (items.length > 1 ? 'Hello, I would like to order these pieces.' : 'Hello, I would like to order this piece.'));
    return out.join('\n');
  }
  function productOrderItem() {
    if (!product) return null;
    var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var vid = idEl ? String(idEl.value) : '';
    var v = (product.variants || []).filter(function (x) { return String(x.id) === vid; })[0] || (product.variants || [])[0];
    if (!v) return null;
    var form = mainForm();
    var qtyEl = form && form.querySelector('[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
    var names = (product.options || []).map(function (o) { return o.name || o; });
    return {
      title: product.title,
      options: (v.options || []).map(function (val, i) { return { name: names[i] || '', value: val }; }),
      barcode: v.barcode, qty: qty, line: v.price * qty
    };
  }
  function message(order) {
    if (order) {
      var item = productOrderItem();
      if (item) return orderMessage([item], location.origin + location.pathname);
    }
    var a = isAr();
    var title = '', price = '';
    if (product) {
      title = product.title;
      var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var vid = idEl ? String(idEl.value) : '';
      var v = (product.variants || []).filter(function (x) { return String(x.id) === vid; })[0] || (product.variants || [])[0];
      if (v) price = money(v.price);
    }
    var url = location.origin + location.pathname;
    var lines;
    if (title) {
      var opts = selectedOptions();
      var form = mainForm();
      var qtyEl = form && form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      if (order) {
        lines = a ? [
          '*طلب من الموقع الإلكتروني* – falaqjewelry.com', '',
          'القطعة: ' + title,
          opts ? 'الخيار: ' + opts : null,
          'الكمية: ' + qty,
          price ? 'السعر: ' + price + ' ر.ع' : null,
          'الرابط: ' + url, '',
          'السلام عليكم، أرغب بطلب هذه القطعة.'
        ] : [
          '*Website order* – falaqjewelry.com', '',
          'Piece: ' + title,
          opts ? 'Option: ' + opts : null,
          'Quantity: ' + qty,
          price ? 'Price: ' + price + ' OMR' : null,
          'Link: ' + url, '',
          'Hello, I would like to order this piece.'
        ];
      } else {
        lines = a ? [
          '*استفسار من الموقع الإلكتروني* – falaqjewelry.com', '',
          'القطعة: ' + title,
          opts ? 'الخيار: ' + opts : null,
          price ? 'السعر: ' + price + ' ر.ع' : null,
          'الرابط: ' + url, '',
          'السلام عليكم، أودّ الاستفسار عن هذه القطعة.'
        ] : [
          '*Website enquiry* – falaqjewelry.com', '',
          'Piece: ' + title,
          opts ? 'Option: ' + opts : null,
          price ? 'Price: ' + price + ' OMR' : null,
          'Link: ' + url, '',
          'Hello, I would like to ask about this piece.'
        ];
      }
    } else {
      lines = a ? [
        '*استفسار من الموقع الإلكتروني* – falaqjewelry.com', '',
        'الصفحة: ' + url, '',
        'السلام عليكم، عندي استفسار.'
      ] : [
        '*Website enquiry* – falaqjewelry.com', '',
        'Page: ' + url, '',
        'Hello, I have a question.'
      ];
    }
    return lines.filter(function (l) { return l !== null; }).join('\n');
  }
  function cartMessage(cart) {
    var a = isAr();
    var c = cur(cart.currency);
    var items = (cart.items || []).map(function (it) {
      var name = it.product_title + (it.variant_title ? ' – ' + it.variant_title : '');
      return '• ' + name + ' × ' + it.quantity + ' – ' + money(it.final_line_price) + ' ' + c;
    });
    var lines = a ? [
      '*طلب من الموقع الإلكتروني* – falaqjewelry.com', ''
    ].concat(items).concat([
      '', 'المجموع: ' + money(cart.items_subtotal_price) + ' ' + c + ' (قبل التوصيل)', '',
      'السلام عليكم، أرغب بطلب هذه القطع.'
    ]) : [
      '*Website order* – falaqjewelry.com', ''
    ].concat(items).concat([
      '', 'Total: ' + money(cart.items_subtotal_price) + ' ' + c + ' (before delivery)', '',
      'Hello, I would like to order these pieces.'
    ]);
    return lines.join('\n');
  }
  function waUrl(store, text) { return 'https://wa.me/' + store.phone + '?text=' + encodeURIComponent(text); }
  function report(kind, store, value) {
    var data = { source: kind, store: store.name, value: value || 0, currency: 'OMR' };
    try { if (window.fbq) window.fbq('trackCustom', 'WhatsAppOrder', data); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('falaq_whatsapp_order', data); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !isRouterLink(a)) return;
    var store = pickStore();
    var mode = a.getAttribute('data-falaq-wa');
    if (mode === 'order-cart') {
      /* The cart is read at click time so the message matches what is in it now. */
      e.preventDefault();
      var root = isAr() ? '/ar' : '';
      fetch(root + '/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          /* Barcodes are not in the cart, so read each product once (in parallel) and match by variant. */
          var handles = [];
          (cart.items || []).forEach(function (it) { if (handles.indexOf(it.handle) < 0) handles.push(it.handle); });
          return Promise.all(handles.map(function (h) {
            return fetch(root + '/products/' + h + '.js', { credentials: 'same-origin' })
              .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
          })).then(function (prods) {
            var codes = {};
            prods.forEach(function (p) { (p && p.variants || []).forEach(function (v) { codes[v.id] = v.barcode; }); });
            var items = (cart.items || []).map(function (it) {
              return { title: it.product_title, options: it.options_with_values, barcode: codes[it.variant_id] || '', qty: it.quantity, line: it.final_line_price };
            });
            report('cart', store, cart.items_subtotal_price / 100);
            location.href = waUrl(store, items.length ? orderMessage(items) : message(false));
          });
        })
        .catch(function () { location.href = waUrl(store, message(false)); });
      return;
    }
    if (mode === 'order') {
      var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var v = product && (product.variants || []).filter(function (x) { return idEl && String(x.id) === String(idEl.value); })[0];
      report('product', store, v ? v.price / 100 : 0);
    }
    a.href = waUrl(store, message(mode === 'order'));
    a.target = '_blank';
    a.rel = 'noopener';
  }, true);

  /* "Order on WhatsApp" buttons, placed by script so they survive the theme re-rendering the cart. */
  var WA_ICON = '<svg width="20" height="20" viewBox="0 0 32 32" aria-hidden="true"><path fill="#25D366" d="M16 3a13 13 0 0 0-11.2 19.6L3 29l6.6-1.7A13 13 0 1 0 16 3z"/><path fill="#fff" d="M21.8 18.7c-.3-.2-1.9-.9-2.2-1s-.5-.2-.7.2-.8 1-1 1.2-.4.2-.7.1a8.7 8.7 0 0 1-4.3-3.8c-.3-.5.3-.5 1-1.6.1-.2 0-.4 0-.5l-1-2.4c-.3-.6-.5-.5-.7-.5h-.6a1.2 1.2 0 0 0-.9.4 3.6 3.6 0 0 0-1.1 2.7 6.3 6.3 0 0 0 1.3 3.3 14.4 14.4 0 0 0 5.5 4.9c2 .9 2.8.9 3.8.8a3.2 3.2 0 0 0 2.1-1.5 2.6 2.6 0 0 0 .2-1.5c-.1-.2-.3-.2-.6-.4z"/></svg>';
  function orderLink(mode) {
    var a = document.createElement('a');
    a.className = 'falaq-wa-order';
    a.setAttribute('data-falaq-wa', mode);
    a.href = (isAr() ? '/ar' : '') + '/pages/stores#whatsapp';
    a.innerHTML = WA_ICON + '<span>' + (isAr() ? 'اطلبي عبر واتساب' : 'Order on WhatsApp') + '</span>';
    return a;
  }
  function injectStyle() {
    if (document.getElementById('falaq-wa-order-css')) return;
    var s = document.createElement('style');
    s.id = 'falaq-wa-order-css';
    s.textContent =
      '.falaq-wa-order{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:48px;padding:12px 18px;' +
      'border:1px solid rgba(14,61,44,.25);border-radius:var(--btn-border-radius,8px);background:#fff;color:#0e3d2c;' +
      'font-weight:600;font-size:15px;line-height:1.2;text-decoration:none;transition:background .15s,border-color .15s;-webkit-tap-highlight-color:transparent}' +
      '.falaq-wa-order:hover{background:rgba(14,61,44,.04);border-color:rgba(14,61,44,.45)}' +
      '.falaq-wa-order:active{transform:scale(.99)}' +
      '.falaq-wa-order--product{margin-top:10px}' +
      '.falaq-wa-order--cart{margin-top:8px}' +
      '.falaq-adding-note{display:none}' +
      'cart-drawer.falaq-adding .falaq-adding-note{display:flex;align-items:center;gap:10px;padding:14px 20px;font-size:14px;color:#0e3d2c}' +
      'cart-drawer.falaq-adding .falaq-adding-note::before{content:"";width:16px;height:16px;border-radius:50%;border:2px solid rgba(14,61,44,.2);border-top-color:#0e3d2c;animation:falaqspin .7s linear infinite;flex:none}' +
      'cart-drawer.falaq-adding [id^="CartDrawerEmpty-"]{display:none!important}' +
      'cart-drawer.falaq-adding [id^="CartDrawerBody-"],cart-drawer.falaq-adding [id^="CartDrawerFooter-"]{opacity:.45;pointer-events:none;transition:opacity .2s}' +
      '@keyframes falaqspin{to{transform:rotate(360deg)}}';
    document.head.appendChild(s);
  }
  function placeButtons() {
    injectStyle();
    /* Product page: under Buy it now, inside the main product form only. */
    var form = mainForm();
    if (form) {
      var row = form.querySelector('.product-form__buttons');
      if (row && !(row.nextElementSibling && row.nextElementSibling.classList.contains('falaq-wa-order'))) {
        var p = orderLink('order');
        p.classList.add('falaq-wa-order--product');
        row.parentNode.insertBefore(p, row.nextSibling);
      }
    }
    /* Cart drawer and cart page: under the Check out row. */
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
      var ref = btn.closest('form') && btn.closest('form').classList.contains('drawer__footer-buttons') ? btn.closest('form') : (btn.parentElement && btn.parentElement.children.length > 1 ? btn.parentElement : btn);
      if (ref.nextElementSibling && ref.nextElementSibling.classList.contains('falaq-wa-order')) return;
      var c = orderLink('order-cart');
      c.classList.add('falaq-wa-order--cart');
      ref.parentNode.insertBefore(c, ref.nextSibling);
    });
  }
  var pt;
  function schedule() { clearTimeout(pt); pt = setTimeout(placeButtons, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeButtons);
  else placeButtons();
  document.addEventListener('cart:updated', schedule);
  try { new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true }); } catch (e) {}

  /* Instant cart: open the drawer the moment Add to cart is tapped. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('is') !== 'product-form') return;
    if (!window.FoxTheme || !FoxTheme.settings || FoxTheme.settings.cartType !== 'drawer') return;
    if (form.closest('quick-view-modal')) return;
    var btn = form.querySelector('[type="submit"]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.show !== 'function') return;
    injectStyle();
    var note = drawer.querySelector('.falaq-adding-note');
    if (!note) {
      var body = drawer.querySelector('[id^="CartDrawerBody-"]');
      note = document.createElement('div');
      note.className = 'falaq-adding-note';
      note.setAttribute('role', 'status');
      if (body && body.parentNode) body.parentNode.insertBefore(note, body);
      else drawer.appendChild(note);
    }
    note.textContent = isAr() ? 'جارٍ الإضافة إلى السلة…' : 'Adding to your cart…';
    drawer.classList.add('falaq-adding');
    try { if (!drawer.open) drawer.show(e.submitter || btn); } catch (err) {}
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      drawer.classList.remove('falaq-adding');
      document.removeEventListener('cart:updated', finish);
      document.removeEventListener('product-ajax:added', finish);
      document.removeEventListener('product-ajax:error', finish);
    }
    document.addEventListener('cart:updated', finish);
    document.addEventListener('product-ajax:added', finish);
    document.addEventListener('product-ajax:error', finish);
    setTimeout(finish, 10000);
  }, true);

  /* Safety net: swap any leftover owner number shown as text for the visitor's store number. */
  function scrub(root) {
    try {
      var store = pickStore();
      var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, null);
      var n, hits = [];
      while ((n = walker.nextNode())) {
        if (n.parentNode && /^(SCRIPT|STYLE|TEXTAREA)$/.test(n.parentNode.nodeName)) continue;
        OWNER_TEXT.lastIndex = 0;
        if (OWNER_TEXT.test(n.nodeValue)) hits.push(n);
      }
      hits.forEach(function (t) { OWNER_TEXT.lastIndex = 0; t.nodeValue = t.nodeValue.replace(OWNER_TEXT, store.label); });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scrub(); });
  else scrub();
})();
